import { useState } from '#imports'
import { ref } from 'vue'

import {
  getBrazeInstance,
  whenBrazeIsReady,
} from '@backmarket/nuxt-module-tracking/getBrazeInstance'

import type { BrazeContentCard } from '../PersonalizedFeed.utils'
/**
 * Fetch and subscribe to Braze Content Cards.
 */
export const useBrazeCards = () => {
  const isRequestingContentCards = ref(true)
  const cards = useState<BrazeContentCard[]>('braze-cards', () => [])

  function getCardsFromBraze() {
    try {
      const instance = getBrazeInstance()
      let cachedCards: BrazeContentCard[] = []
      if (!instance || cards.value.length) {
        isRequestingContentCards.value = false

        return
      }
      isRequestingContentCards.value = true
      instance.requestContentCardsRefresh()
      cachedCards = instance.getCachedContentCards()?.cards || []
      if (cachedCards.length > 0) {
        cards.value = cachedCards
        isRequestingContentCards.value = false
      } else {
        instance.subscribeToContentCardsUpdates((updates) => {
          cards.value = updates.cards
          isRequestingContentCards.value = false
        })
      }
    } catch (err) {
      isRequestingContentCards.value = false
      throw err
    }
  }

  async function waitForBrazeToBeReady() {
    const isEnabled = await whenBrazeIsReady()
    if (!isEnabled) {
      isRequestingContentCards.value = false
    }

    return { isEnabled }
  }

  return {
    cards,
    fetchCards: getCardsFromBraze,
    isRequestingContentCards,
    waitForBrazeToBeReady,
  }
}
